import { API_URLS } from '@chessx/shared/api-routes'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import axiosInstance from '../../network/axiosInstance'
import { toastMixin } from '../../utils/interact'

export interface ChessApiMonthEntry {
  month: string
  year: string
  meta: Record<string, ChessApiMetric>
}

export interface ChessApiMetric {
  last10Time?: number[]
  maxTime?: number
  count?: number
  totalTime?: number
  percentile95?: number
  cv?: number
  failCount?: number
  [key: string]: unknown
}

export interface FetchChessApiResult {
  isLoading: boolean
  data: ChessApiMonthEntry[] | null
  isError: boolean
  error: UseQueryResult['error']
  refetch: UseQueryResult['refetch']
}

export const fetchChessApi = (): FetchChessApiResult => {
  const { isLoading, data, isError, error, refetch } = useQuery({
    queryKey: ['CHESS_API'],
    queryFn: async () => {
      const url = API_URLS.ADMIN_API_ANALYTICS
      const result = await axiosInstance.get(url)
      if (result.data?.status === 200) {
        return result.data?.data?.data as ChessApiMonthEntry[]
      }
      return null
    },
    gcTime: 0
  })

  if (isError) {
    toastMixin.fire({
      title: `Error fetching Chess Engine analytics: ${error}`,
      icon: 'error'
    })
  }

  return { isLoading, data: data || null, isError, error, refetch }
}
